import { FC, useCallback } from 'react';

import dayjs, { Dayjs } from 'dayjs';
import { z } from 'zod';

import { BasicForm, DatePicker } from '@ui-furniture/common/form';
import { Button, HStack } from '@ui-furniture/elements';
import { zod } from '@ui-furniture/lib/utils/zod-validation';

export const dateSchema = z.object({
  date: zod.date({
    rules: { min: dayjs().add(3, 'days'), max: dayjs().add(6, 'months') },
    errorMessage: 'Please select a date between 3 days and 6 months from now',
  }),
});

export type DateChatInputConfig = {
  minDate: Dayjs;
  maxDate: Dayjs;
  inputFormat: string;
  errorMessage: string;
  defaultDate?: Dayjs;
};

export const DateChatInput: FC<{
  onAnswer: (value: string) => void;
  config: DateChatInputConfig;
}> = ({
  onAnswer,
  config: { minDate, maxDate, inputFormat, errorMessage, defaultDate },
}) => {
  const onSubmit = useCallback((data: { date: Dayjs }) => {
    onAnswer(data.date.format('DD/MM/YY'));
  }, []);

  return (
    <BasicForm
      schema={z.object({
        date: zod.date({
          rules: {
            min: minDate,
            max: maxDate,
          },
          errorMessage,
        }),
      })}
      onSubmit={onSubmit}
    >
      <HStack p={2}>
        <DatePicker
          name='date'
          inputFormat={inputFormat}
          views={['year', 'month', 'day']}
          maxDate={maxDate}
          minDate={minDate}
          defaultDate={defaultDate}
        />
        <Button type='submit'>Confirm</Button>
      </HStack>
    </BasicForm>
  );
};
